var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgVoicePhone(props, svgRef) {
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", strokeWidth: 1.5, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M8 17.01l.01-.011M8 5H3.6a.6.6 0 00-.6.6v14.8a.6.6 0 00.6.6h8.8a.6.6 0 00.6-.6V16M16 3v10M13 5v6M22 7v2M10 7v2M19 4v8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })));
}
var ForwardRef = React.forwardRef(SvgVoicePhone);
export default ForwardRef;
//# sourceMappingURL=VoicePhone.js.map